import { Component, Input, OnInit } from '@angular/core';
import { VenturesService } from 'src/app/Shared/Venture/ventures.service';
import { CommonService } from 'src/app/Shared/Common/common.service';

declare var $: any;

@Component({
  selector: 'app-property-venture-view',
  templateUrl: './property-venture-view.component.html',
  styleUrls: ['./property-venture-view.component.css']
})
export class PropertyVentureViewComponent implements OnInit {

  @Input() VentureId: string;
  isLoader: boolean = false;
  ventureInfo: any;

  constructor(private ventureService: VenturesService, private serCommonService: CommonService) { }

  ngOnInit(): void {
    this.isLoader = true;
    this.ventureService.GetVentureDetails(this.VentureId, "0", 0).subscribe((res) => {
      this.isLoader = false;
      if (res.status == 1) {
        console.log(res);
        let venture = [];
        venture = res.body;
        if (venture.length > 0) {
          this.ventureInfo = venture[0];
        }
        else {
          $('.modal').modal('show');
          this.serCommonService.CallToster('E', 'Unable to fine venture details, Please try later');
        }
      }
      else {
        $('.modal').modal('show');
        this.serCommonService.CallToster('E', 'Unable to fine venture details, Please try later');
      }
    }, err =>{
      this.isLoader = false;
      $('.modal').modal('show');
      this.serCommonService.CallToster('E', 'Something went wrong while get venture details, Please try later');
    });
  }

}
